
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ProductVariantsOptionModel } from './Entities.GormCrm.ProductVariantsOption';
import { VariantListModel } from './Entities.GormCrm.VariantList';
import { Model, ModelProperty } from 'models/Model';


export class VariantListOptionModel extends Model<VariantListOptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'name', type: 'string' },
		{ name: 'variantListId', type: 'string' },
		{ name: 'deleted', type: 'Date', isHidden: true },
		{ name: 'productVariantsOptions', type: 'ProductVariantsOptionModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductVariantsOptionModel }, properties: () => { return ProductVariantsOptionModel.classProperties } },
		{ name: 'variantList', type: 'VariantListModel', isHidden: true, isObject: true, new: () => { return new VariantListModel }, properties: () => { return VariantListModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public name: string;
	public variantListId?: string;
	public deleted?: Date;
	public productVariantsOptions: ProductVariantsOptionModel[];
	public variantList?: VariantListModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.name = '';
		this.variantListId = undefined;
		this.deleted = undefined;
		this.productVariantsOptions = [];
		this.variantList = undefined;
		
	}
	getProperties(){
		return VariantListOptionModel.classProperties;
	}
}

